var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"el-tree !h-full",class:{
    'el-tree--highlight-current': _vm.highlightCurrent,
    'is-dragging': !!_vm.dragState.draggingNode,
    'is-drop-not-allow': !_vm.dragState.allowDrop,
    'is-drop-inner': _vm.dragState.dropType === 'inner',
  },attrs:{"role":"tree"}},[(!_vm.isEmpty)?_c('virtual-list',{ref:"virtualList",style:(_vm.treeStyle ? _vm.treeStyle : { height: '100%', 'overflow-y': 'auto' }),attrs:{"start":_vm.startIndex,"data-key":_vm.getNodeKey,"data-sources":_vm.visibleList,"data-component":_vm.itemComponent,"keeps":100,"extra-props":{
      renderAfterExpand: _vm.renderAfterExpand,
      showCheckbox: _vm.showCheckbox,
      renderContent: _vm.renderContent,
      props: _vm.props,
      onNodeExpand: _vm.handleNodeExpand,
    }}}):_vm._e(),(_vm.isEmpty)?_c('div',{staticClass:"el-tree__empty-block"},[_c('span',{staticClass:"el-tree__empty-text"},[_vm._v(_vm._s(_vm.emptyText))])]):_vm._e(),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.dragState.showDropIndicator),expression:"dragState.showDropIndicator"}],ref:"dropIndicator",staticClass:"el-tree__drop-indicator"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }